/**
 * Convert readable text → CONSTANT_CASE
 * Example: "Phone number already exists" → "PHONE_NUMBER_ALREADY_EXISTS"
 */
export const toConstantCase = (text) => {
    if (!text) return "";

    return text
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[^a-zA-Z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
        .toUpperCase();
};
